<title>{{ operationalAssurancesInfoPage.htmlTitle }}</title>
<div class="container">
  <!-- Nav tabs -->
  <div class="operationalTab mb-5">
    <ul class="nav nav-tabs">
      <li class="tab-link bgdgry" *ngFor="let link of tabMenu.links; let i = index"
        [ngClass]="selectedIndex === i ? 'border-blue' : 'border-darkblack'">
        <a class="nav-link" data-bs-toggle="tab" href="#{{ link.href }}" (click)="selectedIndex = i">
          <span class="hideme"> {{ link.title }}</span>
        </a>
      </li>
    </ul>


    <!-- Tab panes -->
    <div class="tab-content pb-5">
      <div id="{{ link.href }}" *ngFor="let link of tabMenu.links; let i = index" class="tab-pane fade"
        [ngClass]="i === selectedIndex ? 'show active container' : 'container'">
        <br />
        <app-operational-assurances-section [sections]="sectionsMap.get(link.title)">
        </app-operational-assurances-section>
      </div>
    </div>
    <div *ngFor="let section of sectionArray">
      <div *ngIf="section.subBody" class="summary" [innerHTML]="section.subBody | mdToHtml"></div>
    </div>
  </div>
</div>